import { Item } from "./Item";
import { Title } from "./Title";

export function ModoEjecucionItems(props) {
  const {
    items,
    separacion_miles,
    separacion_decimales,
    simbolo,
    handleOpenListCompras,
  } = props;

  return (
    <div className="overflow-hidden rounded-xl border border-border bg-surface">
      <div className="flex items-center justify-between border-b border-border px-5 py-4">
        <div>
          <h2 className="text-sm font-semibold">Ejecución por ítem</h2>
          <p className="text-xs text-muted-foreground">
            Presupuestado vs. gasto real y pagos
          </p>
        </div>
        <div className="flex gap-4 text-[11px] text-gray-500">
          <span className="flex items-center gap-1.5">
            <i className="size-2 rounded-full bg-black " />
            Presupuestado
          </span>
          <span className="flex items-center gap-1.5">
            <i className="size-2 rounded-full bg-orange-600" /> Gastado
          </span>
          <span className="flex items-center gap-1.5">
            <i className="size-2 rounded-full bg-green-600" /> Pagado
          </span>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full min-w-[680px] text-sm">
          <thead>
            <tr className="border-b border-border text-[11px] uppercase tracking-wide">
              <th className="px-5 py-2.5 text-left font-medium">Ítem</th>
              <th className="px-3 py-2.5 text-center font-medium">
                Cant. × Meses
              </th>
              <th className="px-3 py-2.5 text-right font-medium">
                Presupuestado
              </th>
              <th className="px-3 py-2.5 text-right font-medium">Gastado</th>
              <th className="px-3 py-2.5 text-right font-medium">Por gastar</th>
              <th className="px-3 py-2.5 text-right font-medium">Pagado</th>
              <th className="px-3 py-2.5 text-right font-medium">Por pagar</th>
              <th className="px-5 py-2.5 text-left font-medium">Avance</th>
              <th className="text-left font-medium">Seleccionar</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {items?.map((title) => {
              return (
                <>
                  <Title
                    it={title}
                    separacion_miles={separacion_miles}
                    separacion_decimales={separacion_decimales}
                    simbolo={simbolo}
                  />
                  {title?.items?.map((item) => (
                    <Item
                      key={item.id}
                      it={item}
                      separacion_miles={separacion_miles}
                      separacion_decimales={separacion_decimales}
                      simbolo={simbolo}
                      items={items}
                      handleOpenListCompras={handleOpenListCompras}
                    />
                  ))}
                </>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
